import { takeLatest, put, call } from 'redux-saga/effects';
import { httpService } from '@commons';

import {
  DELETE_CONTA_AGRARE,
  DELETE_CONTA_AGRARE_PENDING,
  DELETE_CONTA_AGRARE_SUCCESS,
  DELETE_CONTA_AGRARE_FAILURE,
  NEW_FILTER_CONTA_AGRARE
} from '../actionTypes';

const deleteConta = async (id) => {
  return httpService.delApiManager(`/clienteAgrare/delete/${id}`);
}

function* sagaDeleteContaAgrare(action) {
  yield put({ type: DELETE_CONTA_AGRARE_PENDING });

  try {
    yield call(deleteConta, action.id);
    yield put({ type: DELETE_CONTA_AGRARE_SUCCESS });

    yield put({ type: NEW_FILTER_CONTA_AGRARE, newFilter: false });

    if (action.resolve) {
      action.resolve();
    }
  } catch (error) {
    yield put({ type: DELETE_CONTA_AGRARE_FAILURE });

    if (action.resolve) {
      action.resolve();
    }
  }
}

export default function* watchDeleteContaAgrare() {
  yield takeLatest(DELETE_CONTA_AGRARE, sagaDeleteContaAgrare);
}
